import { IconContent } from '@icons';

export const businessCenter: IconContent = {
    md: '<path d="M5 2a1 1 0 0 0-1 1v18H2v1h20v-1h-2V3a1 1 0 0 0-1-1H5Zm8 19h-2v-2h2v2Zm5 0h-4v-3h-4v3H5V3h14v18h-1ZM7 5h2v2H7V5Zm4 0h2v2h-2V5Zm6 0h-2v2h2V5ZM7 8h2v2H7V8Zm6 0h-2v2h2V8Zm2 0h2v2h-2V8Zm-6 3H7v2h2v-2Zm2 0h2v2h-2v-2Zm6 0h-2v2h2v-2ZM7 14h2v2H7v-2Zm6 0h-2v2h2v-2Zm2 0h2v2h-2v-2Z" />',
};
